import React from 'react';
import Checkbox from '../../../components/common/Checkbox';

// Group permissions for better organizastion
const permissionGroups = {
  'Content & Communication': ['Create Post', 'Update Post', 'Delete Post', 'View Notice', 'Create Notice', 'Update Notice', 'Delete Notice', 'View Chat', 'Respond Chat'],
  'Helpdesk': ['Create New User', 'Create Staff Movement', 'Create Access Modification', 'Create Access Termination', 'Create Password Reset'],
  'Procurement & RFQ': ['Create Specification', 'Update Specification', 'Approve Specification', 'Create Requisition', 'Approve Requisition', 'View RFQ', 'Send RFQ', 'View Quote', 'Unlock Quote', 'Update RFQ', 'Access Procurement Settings', 'Modify Procurement Settings', 'Change GL Approvers', 'View Procurement', 'Edit Procurement', 'Delete Procurement'],
  'Bidding Administration': ['Create Bidding Item', 'Edit Bidding Item', 'Delete Bidding Item', 'Manage Bidding Categories', 'View All Bids', 'Export Bidding Data', 'Approve Bidding Items'],
  'Settings': ['View Settings', 'Edit Settings', 'View System Settings', 'Edit System Settings', 'Manage Settings'],
  'Suppliers': ['View Suppliers', 'Add Suppliers', 'Edit Suppliers', 'Delete Suppliers', 'Import Suppliers', 'Export Suppliers'],
  'Asset Management': ['Manage Assets', 'View Assets'],
  'Users & Security': ['Create Users', 'Update User', 'Delete Users', 'View User'],
  'Roles & Permissions': ['Create Role', 'Update Role', 'Delete Role'],
  'Departments': ['Create Department', 'Update Department', 'Delete Department'],
  'Sites': ['Create Site', 'Update Site', 'Delete Site'],
  'Areas': ['Create Area', 'Update Area', 'Delete Area'],
  'Categories': ['Create Category', 'Update Category', 'Delete Category'],
  'Files': ['Upload Files', 'Download Files', 'View Files', 'Delete Files'],
  'Workflows': ['Create Workflow', 'Update Workflow', 'Delete Workflow'],
  'Invoices': ['Create Invoice', 'Update Invoice', 'Delete Invoice'],
  'Payments': ['Create Payment', 'Update Payment', 'Delete Payment'],
  'Water Tanker': ['Manage Tankers'],
  'Dashboards': ['Procurement Dashboard', 'CRM Dashboard', 'Standard Dashboard'],
  'Reporting': ['Chat Report', 'Requisitions Report', 'RFQ Report', 'Water Tanker Report', 'MMS Report', 'Helpdesk Report']
};

function PermissionsForm({ permissions, setPermissions }) {
  const handlePermissionChange = (permission) => {
    setPermissions(prev =>
      prev.includes(permission)
        ? prev.filter(p => p !== permission)
        : [...prev, permission]
    );
  };

  const handleSelectAllGroup = (groupPermissions) => {
    const allSelected = groupPermissions.every(p => permissions.includes(p));
    if (allSelected) {
      // Deselect all in this group
      setPermissions(prev => prev.filter(p => !groupPermissions.includes(p)));
    } else {
      // Select all in this group
      setPermissions(prev => [...new Set([...prev, ...groupPermissions])]);
    }
  };

  return (
    <div className="bg-white p-6 rounded-xl shadow-lg h-full">
      <h2 className="text-xl font-semibold custom-text-neutral-800 mb-6">Permissions</h2>
      <div className="space-y-8">
        {Object.entries(permissionGroups).map(([groupName, groupPermissions]) => (
          <div key={groupName}>
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold custom-text-neutral-700">{groupName}</h3>
              <button
                type="button"
                onClick={() => handleSelectAllGroup(groupPermissions)}
                className="text-sm font-semibold custom-text-secondary-default hover:custom-text-secondary-dark transition-colors"
              >
                {groupPermissions.every(p => permissions.includes(p)) ? 'Deselect All' : 'Select All'}
              </button>
            </div>
            <div className="p-4 border custom-border-neutral-200 rounded-lg">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-4">
                {groupPermissions.map(permission => (
                  <Checkbox
                    key={permission}
                    label={permission}
                    checked={permissions.includes(permission)}
                    onChange={() => handlePermissionChange(permission)}
                  />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default PermissionsForm;